// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyBzb9Jb4dUW0nU6hUNhzFgvi61TcbzySaw",
  authDomain: "orocancerwatch.in",
  projectId: "aiims-bhopal-webapp",
  storageBucket: "aiims-bhopal-webapp.firebasestorage.app",
  messagingSenderId: "351721211275",
  appId: "1:351721211275:web:95dbf27ca32fb45856db8e"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);